import Vue from 'vue';
import Vuex from 'vuex';
import { configuration } from './setting';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    configuration: {},
    token: '',
    user: {},
    patient: {},
    ifCompose: false,// 量表当前编辑状态

  },
  mutations: {
    updateToken(state, data) {
      state.token = data;
    },
    updateUser(state, data) {
      state.user = data;
    },
    updateConfiguration(state, data) {
      state.configuration = data;
    },
    updatePatient(state, data) {
      state.patient = data;
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
  },
});

export default store;
